module.exports = __webpack_public_path__ + "media/images/react/members/saracoin-66dd82192ec6da2fc81b456be499c5b2.svg";